import React from 'react';
import {MobileSortContainer} from "./mobile-sort.styles";

const MobileSort = ({clickHandler, title, sortName, itemClassName = ''}) => {
    return (
        <MobileSortContainer className='d-lg-none mb-5'>
            <ul className='l-s-t-none p-0 m-0'>
                <li onClick={clickHandler} className={itemClassName}>
                    <div className='d-flex align-items-center'>
                        <i className='icon-sort ms-3' />
                        <p className='mb-0 dark-gray ms-3'>{title}</p>
                        <p className='mb-0 gray-color'>{sortName}</p>
                    </div>
                    <i className='icon-arrow arrow'/>
                </li>
            </ul>
        </MobileSortContainer>
    );
};

export default MobileSort;
